<template>
  <b-form-group label="CEP">
    <b-input-group>
      <masked-input
        ref="cep"
        v-model="value_"
        :class="{'is-invalid' : erroCep}"
        :mask="[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
        class="form-control"
        :disabled="disable"
        @change="buscar()"
      />
      <b-input-group-append>
        <b-button
          v-b-tooltip.hover
          title="Buscar endereço completo pelo CEP"
          variant="primary"
          style="float:right"
          :disabled="disable"
          @click="buscarEndereco()"
        >
          <feather-icon icon="SearchIcon" />
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>

<script>
import estadoApi from '@/shared/components/estado-select/api'
import municipioApi from '@/shared/components/municipio-select/api'

export default {
  name: 'CepInput',
  props: {
    value: {
      type: String,
      default: () => null,
    },
    externo: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valueAttr: null,
      dadosEndereco: {},
      erroCep: false,
    }
  },
  computed: {
    value_: {
      get() {
        return this.valueAttr ? this.valueAttr : this.value
      },
      set(newValue) {
        this.valueAttr = newValue
        return this.valueAttr
      },
    },
  },
  watch: {
    value(val, oldVal) {
      if (val !== oldVal) {
        this.valueAttr = val
      }
    },
  },
  /* eslint no-underscore-dangle: 0 */
  methods: {
    async buscarEndereco() {
      this.erroCep = this.cepInvalido(this.value_)
      if (!this.erroCep) {
        const cep = this.value_.replace(/\D/g, '')
        const dados = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
        const endereco = await dados.json()

        this.$set(this.dadosEndereco, 'logradouro', endereco.logradouro)
        this.$set(this.dadosEndereco, 'bairro', endereco.bairro)
        this.$set(this.dadosEndereco, 'complemento', endereco.complemento)
        this.$set(this.dadosEndereco, 'cep', this.value_)

        this.$emit('atualizar-endereco', this.dadosEndereco)

        estadoApi.getEstadosResumidos([{
          colunas: ['sigla'],
          valor: endereco.uf,
          soletrado: true,
        }], this.externo).then(payload => {
          this.$set(this.dadosEndereco, 'uf', payload.data[0])
          this.$emit('atualizar-endereco', this.dadosEndereco)
        })

        municipioApi.getMunicipiosResumidos([{
          colunas: ['nome'],
          valor: endereco.localidade,
        }], this.externo).then(payload => {
          this.$set(this.dadosEndereco, 'cidade', payload.data[0])
          this.$emit('atualizar-endereco', this.dadosEndereco)
        })
      }
    },
    cepInvalido(cep) {
      return !cep || cep.replace(/\D/g, '').length < 8
    },
    buscar() {
      if (!this.disable) {
        this.buscarEndereco()
      }
    },
  },
}
</script>
